import { render } from "./SortToggle.vue?vue&type=template&id=8a847ae0&scoped=true"
import script from "./SortToggle.vue?vue&type=script&lang=js"
export * from "./SortToggle.vue?vue&type=script&lang=js"

import "./SortToggle.vue?vue&type=style&index=0&id=8a847ae0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a847ae0"]])

export default __exports__